import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_CASES_PER_CIRCULATING_NURSE_QUERY_KEY } from "../types/CommonTypes";
import { GET_CASES_PER_OT_RESPONSE } from "../types/ResponseTypes";

async function getCasesPerNurse(
  tenantId?: string,
  hospitalId?: string,
  queryString?: string
): Promise<GET_CASES_PER_OT_RESPONSE> {
  const baseUrl = "analytics/circulating-nurse-cases";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetCasesPerNurseQuery(
  tenantId?: string,
  hospitalId?: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [GET_CASES_PER_CIRCULATING_NURSE_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getCasesPerNurse(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
    enabled: !!tenantId && !!hospitalId,
  });
}
